import React, { useState, useRef, useEffect } from "react";

import { CloseOutlined } from "@ant-design/icons";
import Interweave from "interweave";
import { Modal } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import ReactPlayer from "react-player";

import styles from "./TeaserSongListComponent.module.css";
import { ButtonComponent } from "../../../helper/ReusableComponents";

const TeaserSongListComponent = ({ data, cmsData,cmsDataCopy }) => {
  const myRef = useRef(null);
  const scrollToRef = () => window.scrollTo(0, 500) 
  const genresArr = [
    "#0D4045",
    "#A69984",
    "#A67894",
    "#776BBE",
    "#5D9086",
    "#E47D5E",
    "#8E9FB0",
    "#F1557C",
    "#476A8A",
  ];

  const reactPlayerRef = useRef(null);

  const [showVideoThumbnail, setShowVideoThumbnail] = useState(true);
  const [selectedChapter, setSelectedChapter] = useState("");

  const [videos, setVideos] = useState([]);
  const [playingVideo, setPlayingVideo] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [activeGenre, setActiveGenre] = useState("All");
  const [isGenreConcertSeries, setisGenreConcertSeries] = useState(true);
  const [isGenreStudioEvents, setisGenreStudioEvents] = useState(true);
  const [state, setState] = useState({
    progress: 0,
    duration: 0,
    playing: false,
  });
  const executeScroll = () => {
    scrollToRef(myRef)
  }
  useEffect(() => {
    if (data !== undefined) {
      const clonedData = data.map((video) => ({
        ...video,
        chapters: video.chapters.map((chapter, idx) => ({
          ...chapter,
          ends: video.chapters[idx + 1]?.seconds,
        })),
      }));
      setVideos(clonedData);
      setPlayingVideo(clonedData[0]);
      setSelectedChapter(clonedData[0]?.chapters[0]?._id);
    }
  }, [data]);

  /**
   * Handle Genre selection
   * @param {object} genre
   * @param {string} genreVal
   */
  const onGenreSelect = (genre, genreVal) => {
    if (isMobile) setShowModal(true);

    setPlayingVideo(genre);
    setActiveGenre(genreVal);

    if (genreVal !== "All" && activeGenre !== genreVal) {
      setSelectedChapter(genre.chapters[0]?._id);
      setTimeout(() => {
        handleSeekTo(genre?.chapters[0]?.seconds, genre?.chapters[0]?._id);
        handlePause();
      }, 1000);
    }
  };

  /**
   * Handle chapter change with same video
   * @param {int} seekValue
   * @param {string} chapterId
   * @param {object} videoData
   */
  const handleSongChange = (seekValue, chapterId, videoData) => {
    setShowModal(false);
    setPlayingVideo(videoData);
    setTimeout(() => {
      handleSeekTo(seekValue, chapterId);
    }, 1000);
  };

  const handlePlayPause = (status, seekValue) => {
    setShowModal(false);
    setState({ ...state, playing: status });
  };

  const handlePlay = () => {
    setState({ ...state, playing: true });
    setShowVideoThumbnail(false);
    setShowModal(false);
  };

  const handlePause = () => {
    setState({ ...state, playing: false });
  };

  /**
   * Seek to specfic chapter in video
   * @param {int} value seek time
   * @param {string} chapterId
   */
  const handleSeekTo = (value, chapterId) => {
    setSelectedChapter(chapterId);
    setState({ ...state, playing: true });
    reactPlayerRef?.current?.seekTo(parseFloat(value));
  };

  const toggleModal = (seekTime, chapterId,video) => {
    setShowModal(!showModal);
    handleSeekTo(seekTime ?? 0.1, chapterId ?? video?._id);
  };

  const RenderAllSonglist = () => (
    <div>
      {videos.length > 0 &&
        videos
          .filter((video) => {
            if (
              (isGenreConcertSeries && isGenreStudioEvents) ||
              (!isGenreConcertSeries && !isGenreStudioEvents)
            ) {
              return video;
            } else if (isGenreConcertSeries) return video.category === 0;
            else return video.category === 1;
          })
          .map((video, idx) => (
            <ul key={idx}>
              <h5 onClick={() => {
                video._id === playingVideo?._id
                ? handleSeekTo(0.1,video?.chapters[0]?._id ?? video?._id)
                : handleSongChange(0.1, video?.chapters[0]?._id ?? video?._id, video)
              }} style={((video?.chapters[0]?._id ?? video._id )===  playingVideo?._id) ? {cursor:"pointer",color:"#1a92d6", direction: "initial"} :{cursor:"pointer", direction: "initial"}}>{video.title}</h5>
              {video.chapters.map(({ _id, title, seconds, ends }) => (
                <div
                  key={_id}
                  className="d-flex flex-row-reverse justify-content-between align-items-center"
                >
                  <li
                    key={_id}
                    className={`${styles.band_song_item} ${
                      _id === selectedChapter ? styles.active : ""
                    }`}
                    onClick={() =>
                      video._id === playingVideo?._id
                        ? handleSeekTo(seconds, _id)
                        : handleSongChange(seconds, _id, video)
                    }
                  >
                    <p>{title}</p>
                  </li>
                  {_id === selectedChapter && (
                    <button
                      className={`${styles.band_chapter_button} ${
                        _id === selectedChapter ? styles.active : ""
                      }`}
                    >
                      <img
                        width={28}
                        height={28}
                        src={
                          !playing
                            ? "/assets/images/active_play_icon24.svg"
                            : "/assets/images/active_pause_icon24.svg"
                        }
                        alt="play-icon"
                        onClick={() => handlePlayPause(!playing, seconds)}
                      />
                    </button>
                  )}
                </div>
              ))}
            </ul>
          ))}
    </div>
  );

  const RenderGenreSonglist = () => (
    <div>
      <div className={`d-flex ${styles.band_chapterlist_header}`}>
        <p>{activeGenre}</p>
        <CloseOutlined onClick={() => setActiveGenre("All")} />
      </div>
      {playingVideo.chapters.map((chapter, idx) => (
        <div
          key={idx}
          className={`${styles.band_chapterlist_container} ${
            chapter._id === selectedChapter ? styles.active : ""
          }`}
        >
          <div
            className={`d-flex align-items-center ${styles.chapter_thumbnail_wrapper}`}
            onClick={() => handleSeekTo(chapter.seconds, chapter._id)}
          >
            <img
              className={styles.chapter_thumbnail}
              width={65}
              height={65}
              src={process.env.IMAGE_LINK + chapter?.thumbnail}
              alt="chapter-thumbnail"
            />
            <p>{chapter?.title}</p>
          </div>
          {chapter?._id === selectedChapter ? (
            <button className={styles.band_chapter_button}>
              <img
                width={28}
                height={28}
                src={
                  !playing
                    ? "/assets/images/active_play_icon32.svg"
                    : "/assets/images/active_pause_icon32.svg"
                }
                alt="play-icon"
                onClick={() => handlePlayPause(!playing)}
              />
            </button>
          ) : (
            <button className={styles.band_chapter_button}>
              <img
                width={28}
                height={28}
                src="/assets/images/play_icon24.svg"
                alt="play-icon"
                onClick={() => handleSeekTo(chapter.seconds, chapter._id)}
              />
            </button>
          )}
        </div>
      ))}
    </div>
  );

  const { playing } = state;

  return (
    <section className={styles.band_teaser_container}>
      <div className="container-fluid">
        <div className="row">
          <div className={`col-md-4 ${styles.band_teaser_songlist_container}`}>
            <div className={styles.band_teaser_list_header}>
              <h2>
                {cmsData?.teaser_heading !== undefined
                  ? cmsData?.teaser_heading
                  : "Teaser Songlist"}
              </h2>
              <p>
                {cmsDataCopy?.teaser_heading !== undefined
                  ? <Interweave allowElements={false} content={cmsDataCopy?.teaser_heading} />
                  : "(Click on any song to cue it up in the video player)"}
              </p>
            </div>
            <div className={styles.band_songlist_container}>
              {activeGenre === "All" ? (
                <RenderAllSonglist />
              ) : (
                <RenderGenreSonglist />
              )}
            </div>
          </div>
          <div ref={myRef} className={`col-md-8 ${styles.band_teaser_player_container}`}>
            <div className={styles.band_teaser_player_wrapper}>
              <ReactPlayer
                ref={reactPlayerRef}
                className={styles.band_teaser_player}
                url={playingVideo?.url}
                playsInline
                light={
                  showVideoThumbnail && !playing
                    ? `"${process.env.IMAGE_LINK + playingVideo?.thumbnail}"`
                    : false
                }
                playIcon={
                  <img
                    src="/assets/images/play_button.svg"
                    alt="play-icon"
                    onClick={handlePlay}
                  />
                }
                onClickPreview={() => handlePlay()}
                width="100%"
                playing={playing}
                onPlay={handlePlay}
                onPause={handlePause}
                onEnded={() => setShowVideoThumbnail(true)}
                onDuration={(duration) => {
                  setState({ ...state, duration });
                }}
                controls
              />
            </div>
            <div className={styles.band_teaser_filter_wrapper}>
              <div className={`d-flex ${styles.arrange_margin_top_bottom_auto} justify-content-between `}>
                <h5 className={styles.arrange_margin_top_bottom_auto}>
                  {cmsData?.genre_heading !== undefined
                    ? cmsData?.genre_heading
                    : "Genres"}
                </h5>
                <div className="d-flex flex-wrap genres-checkbox-option">
                  <div className="d-flex ">
                    <input
                      type="checkbox"
                      name="genre-concert-series"
                      className={`band-genre-checkbox ${styles.arrange_margin_top_bottom_auto} me-2`}
                      checked={isGenreConcertSeries}
                      onChange={(value) => {
                        setisGenreConcertSeries(!isGenreConcertSeries);
                      }}
                    />
                    <label
                      htmlFor="genre-concert-series"
                      className={`${styles.band_genre_category_label} ${styles.arrange_margin_top_bottom_auto}`}
                    >
                      Concert Series
                    </label>
                  </div>
                  <div className={`d-flex ${styles.arrange_margin_top_bottom_auto} ms-5`}>
                    <input
                      type="checkbox"
                      name="genre-studio-events"
                      className={`band-genre-checkbox ${styles.arrange_margin_top_bottom_auto} me-2`}
                      checked={isGenreStudioEvents}
                      onChange={(value) =>
                        setisGenreStudioEvents(!isGenreStudioEvents)
                      }
                    />
                    <label
                      htmlFor="genre-studio-events"
                      className={`${styles.band_genre_category_label} ${styles.arrange_margin_top_bottom_auto}`}
                    >
                      Studio & Events
                    </label>
                  </div>
                </div>
              </div>
              <div className={styles.band_teaser_filter_btn_container}>
                <ButtonComponent
                  data={{
                    key: "all",
                    type: "button",
                    style: {
                      backgroundColor: "#092637",
                    },
                    className: `${styles.band_teaser_filter_btn} ${
                      "All" === activeGenre &&
                      styles.band_teaser_filter_btn_active
                    }`,
                    onClick: () => onGenreSelect(playingVideo, "All"),
                  }}
                >
                  All
                </ButtonComponent>
                {videos.length > 0 &&
                  videos.filter((video) => {if((isGenreConcertSeries && isGenreStudioEvents)|| (!isGenreConcertSeries && !isGenreStudioEvents)){
                    return video
                  }else if(isGenreConcertSeries) return video.category === 0
                else return video.category === 1}).map((genre, idx) => (
                    <ButtonComponent
                      key={idx}
                      data={{
                        key: idx,
                        type: "button",
                        style: {
                          backgroundColor: genre.category === 0 ? "#1A92D6" :genre.category === 1 ? "#264DA7" : "#808080",
                        },
                        className: `${styles.band_teaser_filter_btn} ${
                          genre.title === activeGenre &&
                          styles.band_teaser_filter_btn_active
                        }`,
                        onClick: () => onGenreSelect(genre, genre.title),
                      }}
                    >
                      {genre.title}
                    </ButtonComponent>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        centered
        show={showModal}
        contentClassName={styles.band_teaser_songlist_modal_container}
        onHide={() => setShowModal(false)}
      >
        <Modal.Body onClick={executeScroll}>
          <div className={styles.band_teaser_songlist_modal_header}>
            {activeGenre}
            <CloseOutlined
              className="modal_close"
              onClick={() => setShowModal(false)}
            />
          </div>
          <div className={styles.band_teaser_songlist_modal_body}>
            {activeGenre === "All" ? (
              <div>
                {videos.length > 0 &&
                  videos.map((video, idx) => (
                    <ul key={idx}>
                      <h5>{video.title}</h5>
                      {video.chapters.map(({ _id, title, seconds, ends }) => (
                        <li
                          key={_id}
                          className={`${
                            styles.band_teaser_songlist_modal_header
                          } ${_id === selectedChapter ? "active" : ""}`}
                          onClick={() =>
                            video._id === playingVideo?._id
                              ? toggleModal(seconds, _id,video)
                              : handleSongChange(seconds, _id, video)
                          }
                        >
                          <p>{title}</p>
                        </li>
                      ))}
                    </ul>
                  ))}
              </div>
            ) : (
              <div>
                {playingVideo.chapters?.length > 0 ?
                playingVideo.chapters.map((chapter, idx) => (
                  <div
                    key={idx}
                    className={`${styles.band_chapterlist_modal_container} ${
                      chapter._id === selectedChapter ? styles.active : ""
                    }`}
                    onClick={() => toggleModal(chapter.seconds, chapter._id)}
                  >
                    <div className="d-flex align-items-center">
                      <img
                        className={styles.chapter_thumbnail}
                        width={65}
                        height={65}
                        src={process.env.IMAGE_LINK + chapter.thumbnail}
                        alt="chapter-thumbnail"
                      />
                      <p>{chapter.title}</p>
                    </div>
                  </div>
                )) : (<div
                  key={playingVideo._id}
                  className={`${styles.band_chapterlist_modal_container} ${
                    playingVideo._id === selectedChapter ? styles.active : ""
                  }`}
                  onClick={() => toggleModal(playingVideo.seconds, playingVideo._id,playingVideo)}
                >
                  <div className="d-flex align-items-center">
                    <img
                      className={styles.chapter_thumbnail}
                      width={65}
                      height={65}
                      src={process.env.IMAGE_LINK + playingVideo.thumbnail}
                      alt="chapter-thumbnail"
                    />
                    <p>{playingVideo.title}</p>
                  </div>
                </div>)}
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default TeaserSongListComponent;
